<template>
  <ModalBase
    :titel="titel"
    :show="show"
    :type="type"
    :button-confirm-spinner="buttonConfirmSpinner"
    :button-cancel-text="buttonCancelText"
    :button-confirm-text="buttonConfirmText"
    @on-confirm="$emit('onConfirm')"
    @on-cancel="$emit('onCancel')"
  >
    <template #icon>
      <BIconExclamationCircle v-if="type === 'warning'" />
      <BIconInfoCircle v-else-if="type === 'info'" />
    </template>

    <template #content>
      <div class="mt-2">
        <p class="text-sm text-secondary-lighter">
          {{ text }}
        </p>
      </div>
    </template>
  </ModalBase>
</template>

<script setup>
import {
  BIconExclamationCircle,
  BIconInfoCircle
} from 'bootstrap-icons-vue'
import ModalBase from '@/components/shared/modals/ModalBase.vue'

defineEmits(['onConfirm', 'onCancel'])

defineProps({
  type: {
    type: String,
    default: 'warning'
  },
  show: {
    type: Boolean,
    required: true
  },
  titel: {
    type: String,
    required: true
  },
  text: {
    type: String,
    required: true
  },
  buttonCancelText: {
    type: String,
    default: 'Abbrechen'
  },
  buttonConfirmText: {
    type: String,
    default: 'Bestätigen'
  },
  buttonConfirmSpinner: {
    type: Boolean,
    default: false
  }
})
</script>

<style scoped></style>
